export type DeviceTypeDetails = {
    id: string;
    name: string;
    slug: string;
    supportOperatorsList: boolean;
    operatorListMode: DeviceTypeOperatorListOptions;
    maximumOperators: number;
    resultTypes?: ResultType[];
};

export type DeviceTypeDetailsAPI = {
    id: string;
    name: string;
    settings: {
        supportPermissions: boolean;
        supportRole: boolean;
        supportIncrementalOperatorLists: boolean;
        supportFullOperatorLists: boolean;
        operatorListMode: DeviceTypeOperatorListOptions;
        maximumOperators: number;
    };
    resultTypes?: ResultTypeAPI[];
};

export type ResultTypeAPI = {
    id: string;
    name: string;
};

export type ResultType = {
    id: string;
    name: string;
};

export type DeviceTypeDetailsUpdateAPI = {
    id: string;
    settings: {
        operatorListMode: DeviceTypeOperatorListOptions;
    };
};

export const DeviceTypeOperatorListOptionsCodes = {
    INACTIVE: 'INACTIVE',
    OPERATOR_LIST: 'OPERATOR_LIST',
    OPERATOR_LIST_WITH_PASSWORD: 'OPERATOR_LIST_WITH_PASSWORD',
} as const;

export type DeviceTypeOperatorListOptions =
    (typeof DeviceTypeOperatorListOptionsCodes)[keyof typeof DeviceTypeOperatorListOptionsCodes];
